import React from "react";
import { useState, useMemo } from "react";
import { Button } from "react-bootstrap";
import CustomTable from "../CustomTable";
import RecordCount from "../utils/RecordCount";
import GrantAccessModal from "./GrantAccessModal";

const PendingRegistrations = (props) => {
  const [data, setData] = useState(JSON.parse(props.userEntities));
  const [canGrantAccess, setCanGrantAccess] = useState(props.canGrantAccess);
  const [showGrantAccessModal, setShowGrantAccessModal] = useState(false);
  const [modalUserId, setModalUserId] = useState(null);
  const [modalId340b, setModalId340b] = useState(null);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "full_name",
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <div className="text-nowrap">
            <>
              <a href={`/user/${tableProps.row.original.user_id}`} target="_blank">
                <i className="fa fa-user me-2"></i>
              </a>
              {tableProps.row.original.full_name}
            </>
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        filter: "fuzzyText",
        Cell: (row) => (
          <div>
            <small className="text-muted">{row.value}</small>
          </div>
        ),
      },
      {
        Header: "340B ID — Entity Name",
        accessor: (row) => `${row.id_340b} - ${row.entity_name}`,
        filter: "fuzzyText",
        Cell: (tableProps) => (
          <a href={`/entities/340bid/${tableProps.row.original.id_340b}?tab=users`}>
            {tableProps.row.original.id_340b} - {tableProps.row.original.entity_name}
          </a>
        ),
      },
      {
        Header: "Authorizing Official",
        accessor: "authorizing_official_name",
        filter: "fuzzyText",
        Cell: (row) => <div>{row.value}</div>,
      },
      {
        Header: "Primary Contact",
        accessor: "primary_contact_name",
        filter: "fuzzyText",
        Cell: (row) => <div>{row.value}</div>,
      },
      {
        Header: "Created At Date",
        accessor: "created_at",
        Cell: (row) => <div>{row.value}</div>,
      },
      ...(canGrantAccess
        ? [
            {
              Header: "Actions",
              Cell: (tableProps) => (
                <div className="text-nowrap">
                  <React.Fragment>
                    <Button
                      className="btn btn-success btn-sm ms-2"
                      onClick={() => {
                        setModalUserId(tableProps.row.original.user_id);
                        setModalId340b(tableProps.row.original.id_340b);
                        setShowGrantAccessModal(true);
                      }}
                    >
                      <i className="fa fa-user-check"></i>
                    </Button>
                  </React.Fragment>
                </div>
              ),
            },
          ]
        : []),
    ],
    []
  );

  return (
    <React.Fragment>
      <RecordCount record_count={data.length} record_type="record" />
      <CustomTable columns={columns} data={data} />
      <GrantAccessModal
        show={showGrantAccessModal}
        setShow={setShowGrantAccessModal}
        fullName={
          data.find((row) => row.user_id === modalUserId && row.id_340b === modalId340b)?.full_name
        }
        modalUserId={modalUserId}
        modalId340b={modalId340b}
      />
    </React.Fragment>
  );
};

export default PendingRegistrations;
